/*
 * @Author: cryi.liu
 * @Date: 2020-05-11 17:32:14
 * @LastEditTime: 2020-06-11 16:14:35
 * @Description: write you description
 */
export default {
  namespaced: true,

  state: {
    // 登录 token 值
    token: '',
    // 在线答题 examToken 值
    examToken: '',
  },

  getters: {
    // 获取 token 值
    token({ token }) {
      return token;
    },
    // 获取 examToken 值
    examToken({ examToken }) {
      return examToken;
    },
  },

  mutations: {
    // 设置 token 值
    setToken(state, { token }) {
      state.token = token;
    },
    // 设置 examToken 值
    setExamToken(state, { examToken }) {
      state.examToken = examToken;
    },
  },

  actions: {
    invokeSetToken({ commit }, payload) {
      commit('setToken', payload);
    },
    invokeSetExamToken({ commit }, payload) {
      commit('setExamToken', payload);
    },
  },
};
